import Firebase from '@firebase/app'
import config from '@/store/config.js'
import axios from 'axios'
import '@firebase/firestore'
import '@firebase/auth'

const firebase = Firebase.initializeApp(config.firebase)
const firestore = Firebase.firestore // no firebase use Firebase(to get server timestamp)
const db = firebase.firestore()
const auth = firebase.auth()

/* functions :: getToken
 * - token 발급 및 갱신
 * @param
 * uid : token 발급 및 갱신용
 *
 * @return
 * token : 1시간 짜리 토큰
 */
const baseUrl = config.firebase.functions.baseUrl
const getToken = uid => {
  return new Promise((resolve, reject) => {
    axios.get(`${baseUrl}/token?uid=uid_${uid}`).then(res => {
      if (res.status === 200) resolve(res.data)
      else reject(res)
    })
  })
}

export {firestore, db, auth, getToken}



// WEBPACK FOOTER //
// ./src/firebase/index.js